import * as React from "react";
import { TextBox } from "../../atoms/forms/TextBox";
import { TextBoxMultiLine } from "../../atoms/forms/TextBoxMultiLine";
import { ICommonInputsControls } from "./ICommonInputsControls";

// All the incoming values
interface IProps {
    multiline?: boolean;
    rows?: number;
}

// Outgoing functions
interface IDispatch {
}

// Actual Component
export type AllProps = IProps & IDispatch & ICommonInputsControls<string>;
export const TextInput = (props: AllProps) => {
    // Use TextBoxMultiLine for multiline input, regular TextBox for single line
    if (props.multiline) {
        return (
            <TextBoxMultiLine
                label={props.label || ""}
                value={props.value}
                loading={props.loading}
                disabled={props.disabled}
                required={props.required}
                error={props.error}
                placeholder={props.placeholder}
                prevalidate={props.prevalidate}
                icon={props.icon}
                rows={props.rows}
                onChange={props.onChange}
                onValidate={props.onValidate}
            />
        );
    }

    return (
        <TextBox
            label={props.label || ""}
            value={props.value}
            loading={props.loading}
            disabled={props.disabled}
            required={props.required}
            error={props.error}
            placeholder={props.placeholder}
            prevalidate={props.prevalidate}
            icon={props.icon}
            onChange={props.onChange}
            onValidate={props.onValidate}
        />
    );
};


